/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, days: NonNullable<unknown> }} Partner_Billing_PeriodInputs */



/**
* | output |
* | --- |
* | "{range} · {days} days" |
*
* @param {Partner_Billing_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_period = /** @type {((inputs: Partner_Billing_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.range} · ${i?.days} Tage`)
	return /** @type {LocalizedString} */ (`${i?.range} · ${i?.days} days`)
});